import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { api, setTokens } from '../api.js'
import { useAuth } from '../auth.jsx'
import { Alert } from '../lib.jsx'

const ROLE_PL = { owner: 'właściciel', admin: 'administrator', member: 'członek' }

export default function AcceptInvite() {
  const [params] = useSearchParams()
  const nav = useNavigate()
  const { user } = useAuth()
  const token = params.get('token')

  const [invite, setInvite] = useState(null)
  const [loadErr, setLoadErr] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (!token) { setLoadErr('Brak tokenu zaproszenia w linku'); return }
    api.getInvite(token).then(setInvite).catch(e => setLoadErr(e.message || 'Nie znaleziono zaproszenia'))
  }, [token])

  const submit = async (e) => {
    e.preventDefault()
    setErr(''); setBusy(true)
    try {
      const body = user ? {} : { username, password }
      const t = await api.acceptInvite(token, body)
      setTokens(t.access_token, t.refresh_token)
      nav('/organizations', { replace: true })
    } catch (e) { setErr(e.message || 'Nie udało się zaakceptować zaproszenia') } finally { setBusy(false) }
  }

  if (loadErr) {
    return (
      <div className="login-wrap">
        <div className="card login-card">
          <div className="brand"><div className="logo">G</div><b>generator<span>PDF</span></b></div>
          <Alert kind="err">{loadErr}</Alert>
          <Link to="/login" className="btn btn-primary" style={{ width: '100%', display: 'flex' }}>Przejdź do logowania</Link>
        </div>
      </div>
    )
  }

  if (!invite) return <div className="splash">Wczytywanie zaproszenia…</div>

  return (
    <div className="login-wrap">
      <div className="card login-card">
        <div className="brand"><div className="logo">G</div><b>generator<span>PDF</span></b></div>
        <div className="tag">Zaproszenie do organizacji</div>
        <div className="kvp"><span className="k">Organizacja</span><span>{invite.organization_name}</span></div>
        <div className="kvp"><span className="k">Rola</span><span>{ROLE_PL[invite.role] || invite.role}</span></div>
        <div className="kvp"><span className="k">E-mail</span><span>{invite.email}</span></div>
        <form onSubmit={submit} style={{ marginTop: 18 }}>
          <Alert kind="err">{err}</Alert>
          {!user && (
            <>
              <div className="field"><label>Nazwa użytkownika (nowe konto)</label>
                <input value={username} onChange={e => setUsername(e.target.value)} autoFocus autoComplete="username" required minLength={3} /></div>
              <div className="field"><label>Hasło</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" required minLength={8} /></div>
            </>
          )}
          <button className="btn btn-primary" style={{ width: '100%' }} disabled={busy || (!user && (!username || !password))}>
            {busy ? 'Przetwarzanie…' : 'Akceptuj zaproszenie'}
          </button>
        </form>
      </div>
    </div>
  )
}
